export const getWageText = (canViewWages: boolean, wage: number | string) => {
  if (canViewWages) {
    return `$${wage}`;
  }
  return "$-.--";
};
